export const Colors = {
  red: 'rgba(243, 23, 0, 0.1)',
  green: 'rgba(0, 128, 0, 0.1)',
  yellow: 'rgba(255, 165, 0, 0.1)',
} as const;
